import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import store from "../store";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  // store.dispatch("authorization/checkAuth").then(isLoggedIn => {
  //   if (isLoggedIn && !!to.meta.userMiddleware) {
  //     return to.meta.userMiddleware === store.getters.getUserType
  //       ? next()
  //       : next({ name: "Appointments" });
  //   } else {
  //     return next();
  //   }
  // });
  store.dispatch("authorization/checkAuth").then(() => next());
});
export default router;
